export default __webpack_public_path__ + "static/media/colgante-medialuna.0f9c6d06.png";